import clsx from "clsx";
import { forwardRef, useEffect, useState } from "react";
import styles from "./C138_EmbeddableForm.module.scss";

export interface CheckboxProps {
  id?: string;
  name?: string;
  value?: string;
  label?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  checked?: boolean;
  register?: (
    name: string,
    RegisterOptions?
  ) => { onChange; onBlur; name; ref };
  customClass?: string;
}

export const EmbeddableCheckbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      id,
      name,
      value,
      label,
      checked = false,
      onChange,
      onBlur,
      register,
      customClass = "",
      ...rest
    },
    ref
  ) => {
    const [internalChecked, setInternalChecked] = useState(checked);

    useEffect(() => {
      setInternalChecked(checked);
    }, [checked]);

    const handleCheckboxChange = (
      event: React.ChangeEvent<HTMLInputElement>
    ) => {
      const newCheckedState = event.target.checked;
      setInternalChecked(newCheckedState);

      if (onChange) {
        onChange(event);
      }
    };

    const inputProps = {
      id,
      name,
      value,
      type: "checkbox",
      checked: internalChecked,
      ref,
      onChange: handleCheckboxChange,
      onBlur: onBlur,
      ...(register ? register(name) : {}),
      ...rest,
    };

    return (
      <div
        className={clsx(
          "checkbox",
          styles.checkbox,
          !label && styles["checkbox--no-label"],
          customClass
        )}
      >
        {label ? (
          <>
            <input
              {...inputProps}
              aria-labelledby={name}
              type="checkbox"
              aria-checked={internalChecked}
            />
            <span
              className={clsx("tick", styles.tick)}
              role="presentation"
            ></span>
            <label htmlFor={id}>{label}</label>
          </>
        ) : (
          <label className="no-label">
            <input
              {...inputProps}
              aria-labelledby={name}
              type="checkbox"
              aria-checked={internalChecked}
            />
            <span
              className={clsx("tick", styles.tick)}
              role="presentation"
            ></span>
          </label>
        )}
      </div>
    );
  }
);

EmbeddableCheckbox.displayName = "EmbeddableCheckbox";

export default EmbeddableCheckbox;
